// Токены дизайна редактора позиции (значения из theme/*, не новые цвета).

export const colors = {
    primary: "#1976d2",
    primaryHover: "#1565c0",
    secondary: "#2196f3",
    contentBg: "#F7F9FC",
    surface: "#fff",
    textPrimary: "rgba(0,0,0,0.87)",
    textSecondary: "rgba(0,0,0,0.54)",
    fieldLabel: "#666",
    fieldBorder: "#D0D0D0",
    divider: "rgba(0,0,0,0.12)",
    borderSoft: "rgba(0,0,0,0.08)",
    borderSofter: "rgba(0,0,0,0.06)",
    segmentBg: "#F1F3F7",
    danger: "#f44336",
    dangerBorder: "rgba(244,67,54,0.4)",
    dangerBorderSoft: "rgba(244,67,54,0.2)",
    dangerHover: "rgba(244,67,54,0.04)",
    success: "#2e7d32",
    amber: "#ffb300",
    // Подложки сообщений — прозрачные производные от цветов выше, не новые тона.
    infoBg: "rgba(25,118,210,0.08)",
    infoBorder: "rgba(25,118,210,0.3)",
    warningBg: "rgba(255,179,0,0.12)",
    warningBorder: "rgba(255,179,0,0.45)",
    dangerBg: "rgba(244,67,54,0.08)",
};

export const shadows = {
    panel: "0 0 14px 0 rgba(53,64,82,.05)",
    sticky: "0 -2px 14px 0 rgba(53,64,82,.06)",
    switchThumb: "0 1px 3px rgba(0,0,0,.3)",
    activePill: "0 1px 3px rgba(53,64,82,.16)",
};

export const radii = {
    base: "0.5rem",
    small: "6px",
    order: "8px",
    preview: "10px",
    badge: "12px",
    chip: "22px",
};
